// extracted by mini-css-extract-plugin
module.exports = {"table":"Container_table__lxQDD"};